// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.premium_loader_overlay {
  display: none;
  position: fixed;
  inset: 0;
  z-index: 999;
  align-items: center;
  justify-content: center;
  background: radial-gradient(ellipse at 60% 30%, #fffaf7 0%, #f0f4ff 60%, #eef2ff 100%);
  font-family: "DM Sans", "Poppins", sans-serif;
}

.premium_loader_overlay.show {
  display: flex;
}

.premium_loader_overlay .blob {
  position: fixed;
  border-radius: 50%;
  filter: blur(80px);
  pointer-events: none;
  z-index: 0;
}

.premium_loader_overlay .blob1 {
  width: 320px;
  height: 320px;
  background: rgba(229, 90, 43, 0.08);
  top: -60px;
  right: -60px;
}

.premium_loader_overlay .blob2 {
  width: 280px;
  height: 280px;
  background: rgba(99, 102, 241, 0.07);
  bottom: -60px;
  left: -60px;
}

.premium_loader_content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  width: min(400px, 92vw);
  padding: 0 16px;
  animation: premium_loader_fade_in 0.45s cubic-bezier(0.16, 1, 0.3, 1) both;
}

@keyframes premium_loader_fade_in {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

.premium_loader_overlay .illo {
  position: relative;
  width: 210px;
  height: 210px;
}

@keyframes premium_doc_float {
  0%,
  100% {
    transform: rotate(-7deg) translate(0, 0);
  }
  50% {
    transform: rotate(-7deg) translate(0, -10px);
  }
}

.premium_loader_overlay .g-doc {
  animation: premium_doc_float 3s ease-in-out infinite;
  transform-origin: center;
}

@keyframes premium_pad_float {
  0%,
  100% {
    transform: rotate(7deg) translate(0, 0);
  }
  50% {
    transform: rotate(7deg) translate(0, -6px);
  }
}

.premium_loader_overlay .g-pad {
  animation: premium_pad_float 3s ease-in-out infinite 0.6s;
  transform-origin: center;
}

@keyframes premium_b_a {
  0%,
  100% {
    transform: scaleY(0.4);
  }
  50% {
    transform: scaleY(1);
  }
}

@keyframes premium_b_b {
  0%,
  100% {
    transform: scaleY(0.8);
  }
  50% {
    transform: scaleY(0.3);
  }
}

@keyframes premium_b_c {
  0%,
  100% {
    transform: scaleY(0.55);
  }
  50% {
    transform: scaleY(1);
  }
}

.premium_loader_overlay .bar1 {
  transform-origin: bottom;
  animation: premium_b_a 2.2s ease-in-out infinite;
}

.premium_loader_overlay .bar2 {
  transform-origin: bottom;
  animation: premium_b_b 2.2s ease-in-out infinite 0.25s;
}

.premium_loader_overlay .bar3 {
  transform-origin: bottom;
  animation: premium_b_c 2.2s ease-in-out infinite 0.5s;
}

@keyframes premium_scan {
  0% {
    transform: translate(0, 0) rotate(-10deg);
  }
  25% {
    transform: translate(6px, -20px) rotate(-4deg);
  }
  50% {
    transform: translate(14px, -4px) rotate(8deg);
  }
  75% {
    transform: translate(8px, 14px) rotate(2deg);
  }
  100% {
    transform: translate(0, 0) rotate(-10deg);
  }
}

.premium_loader_overlay .g-glass {
  animation: premium_scan 3s cubic-bezier(0.45, 0, 0.55, 1) infinite;
  transform-origin: 108px 130px;
}

@keyframes premium_lens_glow {
  0%,
  100% {
    opacity: 0.45;
  }
  50% {
    opacity: 0.75;
  }
}

.premium_loader_overlay .lens-fill {
  animation: premium_lens_glow 3s ease-in-out infinite;
}

@keyframes premium_pulse {
  0%,
  100% {
    r: 14;
    opacity: 0.18;
  }
  50% {
    r: 19;
    opacity: 0.32;
  }
}

.premium_loader_overlay .g-pulse {
  animation: premium_pulse 1.8s ease-in-out infinite;
}

@keyframes premium_ck1 {
  0%,
  8% {
    stroke-dashoffset: 24;
    opacity: 0;
  }
  35%,
  100% {
    stroke-dashoffset: 0;
    opacity: 1;
  }
}

@keyframes premium_ck2 {
  0%,
  33% {
    stroke-dashoffset: 24;
    opacity: 0;
  }
  60%,
  100% {
    stroke-dashoffset: 0;
    opacity: 1;
  }
}

@keyframes premium_ck3 {
  0%,
  58% {
    stroke-dashoffset: 24;
    opacity: 0;
  }
  82%,
  100% {
    stroke-dashoffset: 0;
    opacity: 1;
  }
}

.premium_loader_overlay .ck1 {
  stroke-dasharray: 24;
  animation: premium_ck1 2.6s ease-in-out infinite;
}

.premium_loader_overlay .ck2 {
  stroke-dasharray: 24;
  animation: premium_ck2 2.6s ease-in-out infinite;
}

.premium_loader_overlay .ck3 {
  stroke-dasharray: 24;
  animation: premium_ck3 2.6s ease-in-out infinite;
}

@keyframes premium_ls {
  0%,
  100% {
    opacity: 0.22;
  }
  50% {
    opacity: 0.6;
  }
}

.premium_loader_overlay .ls1 {
  animation: premium_ls 2s ease-in-out infinite 0s;
}

.premium_loader_overlay .ls2 {
  animation: premium_ls 2s ease-in-out infinite 0.35s;
}

.premium_loader_overlay .ls3 {
  animation: premium_ls 2s ease-in-out infinite 0.7s;
}

.premium_loader_overlay .text-block {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.premium_loader_overlay .text-main {
  font-size: 17px;
  font-weight: 700;
  color: #0d1f35;
  letter-spacing: -0.4px;
  min-height: 26px;
  position: relative;
  width: 280px;
}

.premium_loader_overlay .text-main span {
  position: absolute;
  left: 0;
  right: 0;
  opacity: 0;
  transform: translateY(8px);
  transition: opacity 0.4s ease, transform 0.4s ease;
  white-space: nowrap;
}

.premium_loader_overlay .text-main span.show {
  opacity: 1;
  transform: translateY(0);
}

.premium_loader_overlay .text-sub {
  font-size: 12.5px;
  color: #94a3b8;
  font-weight: 500;
  letter-spacing: 0.1px;
}

.premium_loader_overlay .steps-wrap {
  display: flex;
  align-items: center;
  gap: 0;
  width: 100%;
}

.premium_loader_overlay .step-node {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  flex: 1 1;
}

.premium_loader_overlay .step-circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #e2e8f0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: #cbd5e1;
  transition: all 0.4s ease;
  position: relative;
}

.premium_loader_overlay .step-circle.done {
  border-color: #22c55e;
  background: #22c55e;
  color: #fff;
}

.premium_loader_overlay .step-circle.active {
  border-color: #e55a2b;
  background: #fff;
  color: #e55a2b;
  box-shadow: 0 0 0 4px rgba(229, 90, 43, 0.15);
}

.premium_loader_overlay .step-circle.active::after {
  content: "";
  position: absolute;
  inset: -4px;
  border-radius: 50%;
  border: 2px solid rgba(229, 90, 43, 0.3);
  animation: premium_ripple 1.2s ease-out infinite;
}

@keyframes premium_ripple {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(1.6);
    opacity: 0;
  }
}

.premium_loader_overlay .step-label {
  font-size: 10px;
  font-weight: 600;
  color: #94a3b8;
  letter-spacing: 0.3px;
  transition: color 0.4s;
}

.premium_loader_overlay .step-label.done {
  color: #22c55e;
}

.premium_loader_overlay .step-label.active {
  color: #0d1f35;
}

.premium_loader_overlay .step-line {
  height: 2px;
  flex: 1 1;
  background: #f1f5f9;
  border-radius: 50px;
  margin-bottom: 20px;
  overflow: hidden;
  position: relative;
}

.premium_loader_overlay .step-line-fill {
  height: 100%;
  width: 0;
  background: linear-gradient(90deg, #22c55e, #e55a2b);
  border-radius: 50px;
  transition: width 0.6s ease;
}

.premium_loader_overlay .bar-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.premium_loader_overlay .bar-track {
  width: 100%;
  height: 6px;
  background: #f1f5f9;
  border-radius: 50px;
  overflow: hidden;
  position: relative;
}

.premium_loader_overlay .bar-shimmer {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.7) 50%,
    transparent 100%
  );
  animation: premium_shimmer 1.5s ease-in-out infinite;
}

@keyframes premium_shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(200%);
  }
}

.premium_loader_overlay .bar-fill {
  height: 100%;
  width: 0;
  border-radius: 50px;
  position: relative;
  background: linear-gradient(90deg, #e55a2b, #f59e0b, #22c55e);
  transition: width 0.55s ease;
}

.premium_loader_overlay .bar-pct {
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  text-align: right;
}

.premium_loader_overlay .bar-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.premium_loader_overlay .bar-head-label {
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.premium_loader_overlay .dots {
  display: flex;
  gap: 6px;
}

@keyframes premium_db {
  0%,
  80%,
  100% {
    transform: scale(0.4);
    opacity: 0.2;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

.premium_loader_overlay .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #cbd5e1;
  animation: premium_db 1.2s ease-in-out infinite;
}

.premium_loader_overlay .dot:nth-child(2) {
  animation-delay: 0.18s;
}

.premium_loader_overlay .dot:nth-child(3) {
  animation-delay: 0.36s;
}

@media (max-width: 420px) {
  .premium_loader_content {
    width: calc(100vw - 32px);
    gap: 24px;
  }

  .premium_loader_overlay .text-main {
    width: 100%;
  }

  .premium_loader_overlay .text-main span {
    white-space: normal;
  }
}
`, "",{"version":3,"sources":["webpack://./src/portfolio_premium_loader.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,sFAAsF;EACtF,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,0EAA0E;AAC5E;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE;;IAEE,wCAAwC;EAC1C;EACA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,oDAAoD;EACpD,wBAAwB;AAC1B;;AAEA;EACE;;IAEE,uCAAuC;EACzC;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE,yDAAyD;EACzD,wBAAwB;AAC1B;;AAEA;EACE;;IAEE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;;IAEE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;;IAEE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,wBAAwB;EACxB,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;EACxB,sDAAsD;AACxD;;AAEA;EACE,wBAAwB;EACxB,qDAAqD;AACvD;;AAEA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,8CAA8C;EAChD;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,kEAAkE;EAClE,6BAA6B;AAC/B;;AAEA;EACE;;IAEE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE;;IAEE,KAAK;IACL,aAAa;EACf;EACA;IACE,KAAK;IACL,aAAa;EACf;AACF;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE;;IAEE,qBAAqB;IACrB,UAAU;EACZ;EACA;;IAEE,oBAAoB;IACpB,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,qBAAqB;IACrB,UAAU;EACZ;EACA;;IAEE,oBAAoB;IACpB,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,qBAAqB;IACrB,UAAU;EACZ;EACA;;IAEE,oBAAoB;IACpB,UAAU;EACZ;AACF;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE;;IAEE,aAAa;EACf;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,0BAA0B;EAC1B,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,gDAAgD;AAClD;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,SAAO;EACP,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,oDAAoD;EACpD,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,oDAAoD;AACtD;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE;;;IAGE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,yBAAyB;IACzB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap\");\n\n.premium_loader_overlay {\n  display: none;\n  position: fixed;\n  inset: 0;\n  z-index: 999;\n  align-items: center;\n  justify-content: center;\n  background: radial-gradient(ellipse at 60% 30%, #fffaf7 0%, #f0f4ff 60%, #eef2ff 100%);\n  font-family: \"DM Sans\", \"Poppins\", sans-serif;\n}\n\n.premium_loader_overlay.show {\n  display: flex;\n}\n\n.premium_loader_overlay .blob {\n  position: fixed;\n  border-radius: 50%;\n  filter: blur(80px);\n  pointer-events: none;\n  z-index: 0;\n}\n\n.premium_loader_overlay .blob1 {\n  width: 320px;\n  height: 320px;\n  background: rgba(229, 90, 43, 0.08);\n  top: -60px;\n  right: -60px;\n}\n\n.premium_loader_overlay .blob2 {\n  width: 280px;\n  height: 280px;\n  background: rgba(99, 102, 241, 0.07);\n  bottom: -60px;\n  left: -60px;\n}\n\n.premium_loader_content {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 32px;\n  width: min(400px, 92vw);\n  padding: 0 16px;\n  animation: premium_loader_fade_in 0.45s cubic-bezier(0.16, 1, 0.3, 1) both;\n}\n\n@keyframes premium_loader_fade_in {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.premium_loader_overlay .illo {\n  position: relative;\n  width: 210px;\n  height: 210px;\n}\n\n@keyframes premium_doc_float {\n  0%,\n  100% {\n    transform: rotate(-7deg) translate(0, 0);\n  }\n  50% {\n    transform: rotate(-7deg) translate(0, -10px);\n  }\n}\n\n.premium_loader_overlay .g-doc {\n  animation: premium_doc_float 3s ease-in-out infinite;\n  transform-origin: center;\n}\n\n@keyframes premium_pad_float {\n  0%,\n  100% {\n    transform: rotate(7deg) translate(0, 0);\n  }\n  50% {\n    transform: rotate(7deg) translate(0, -6px);\n  }\n}\n\n.premium_loader_overlay .g-pad {\n  animation: premium_pad_float 3s ease-in-out infinite 0.6s;\n  transform-origin: center;\n}\n\n@keyframes premium_b_a {\n  0%,\n  100% {\n    transform: scaleY(0.4);\n  }\n  50% {\n    transform: scaleY(1);\n  }\n}\n\n@keyframes premium_b_b {\n  0%,\n  100% {\n    transform: scaleY(0.8);\n  }\n  50% {\n    transform: scaleY(0.3);\n  }\n}\n\n@keyframes premium_b_c {\n  0%,\n  100% {\n    transform: scaleY(0.55);\n  }\n  50% {\n    transform: scaleY(1);\n  }\n}\n\n.premium_loader_overlay .bar1 {\n  transform-origin: bottom;\n  animation: premium_b_a 2.2s ease-in-out infinite;\n}\n\n.premium_loader_overlay .bar2 {\n  transform-origin: bottom;\n  animation: premium_b_b 2.2s ease-in-out infinite 0.25s;\n}\n\n.premium_loader_overlay .bar3 {\n  transform-origin: bottom;\n  animation: premium_b_c 2.2s ease-in-out infinite 0.5s;\n}\n\n@keyframes premium_scan {\n  0% {\n    transform: translate(0, 0) rotate(-10deg);\n  }\n  25% {\n    transform: translate(6px, -20px) rotate(-4deg);\n  }\n  50% {\n    transform: translate(14px, -4px) rotate(8deg);\n  }\n  75% {\n    transform: translate(8px, 14px) rotate(2deg);\n  }\n  100% {\n    transform: translate(0, 0) rotate(-10deg);\n  }\n}\n\n.premium_loader_overlay .g-glass {\n  animation: premium_scan 3s cubic-bezier(0.45, 0, 0.55, 1) infinite;\n  transform-origin: 108px 130px;\n}\n\n@keyframes premium_lens_glow {\n  0%,\n  100% {\n    opacity: 0.45;\n  }\n  50% {\n    opacity: 0.75;\n  }\n}\n\n.premium_loader_overlay .lens-fill {\n  animation: premium_lens_glow 3s ease-in-out infinite;\n}\n\n@keyframes premium_pulse {\n  0%,\n  100% {\n    r: 14;\n    opacity: 0.18;\n  }\n  50% {\n    r: 19;\n    opacity: 0.32;\n  }\n}\n\n.premium_loader_overlay .g-pulse {\n  animation: premium_pulse 1.8s ease-in-out infinite;\n}\n\n@keyframes premium_ck1 {\n  0%,\n  8% {\n    stroke-dashoffset: 24;\n    opacity: 0;\n  }\n  35%,\n  100% {\n    stroke-dashoffset: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes premium_ck2 {\n  0%,\n  33% {\n    stroke-dashoffset: 24;\n    opacity: 0;\n  }\n  60%,\n  100% {\n    stroke-dashoffset: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes premium_ck3 {\n  0%,\n  58% {\n    stroke-dashoffset: 24;\n    opacity: 0;\n  }\n  82%,\n  100% {\n    stroke-dashoffset: 0;\n    opacity: 1;\n  }\n}\n\n.premium_loader_overlay .ck1 {\n  stroke-dasharray: 24;\n  animation: premium_ck1 2.6s ease-in-out infinite;\n}\n\n.premium_loader_overlay .ck2 {\n  stroke-dasharray: 24;\n  animation: premium_ck2 2.6s ease-in-out infinite;\n}\n\n.premium_loader_overlay .ck3 {\n  stroke-dasharray: 24;\n  animation: premium_ck3 2.6s ease-in-out infinite;\n}\n\n@keyframes premium_ls {\n  0%,\n  100% {\n    opacity: 0.22;\n  }\n  50% {\n    opacity: 0.6;\n  }\n}\n\n.premium_loader_overlay .ls1 {\n  animation: premium_ls 2s ease-in-out infinite 0s;\n}\n\n.premium_loader_overlay .ls2 {\n  animation: premium_ls 2s ease-in-out infinite 0.35s;\n}\n\n.premium_loader_overlay .ls3 {\n  animation: premium_ls 2s ease-in-out infinite 0.7s;\n}\n\n.premium_loader_overlay .text-block {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n}\n\n.premium_loader_overlay .text-main {\n  font-size: 17px;\n  font-weight: 700;\n  color: #0d1f35;\n  letter-spacing: -0.4px;\n  min-height: 26px;\n  position: relative;\n  width: 280px;\n}\n\n.premium_loader_overlay .text-main span {\n  position: absolute;\n  left: 0;\n  right: 0;\n  opacity: 0;\n  transform: translateY(8px);\n  transition: opacity 0.4s ease, transform 0.4s ease;\n  white-space: nowrap;\n}\n\n.premium_loader_overlay .text-main span.show {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.premium_loader_overlay .text-sub {\n  font-size: 12.5px;\n  color: #94a3b8;\n  font-weight: 500;\n  letter-spacing: 0.1px;\n}\n\n.premium_loader_overlay .steps-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  width: 100%;\n}\n\n.premium_loader_overlay .step-node {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  flex: 1;\n}\n\n.premium_loader_overlay .step-circle {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 2px solid #e2e8f0;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  color: #cbd5e1;\n  transition: all 0.4s ease;\n  position: relative;\n}\n\n.premium_loader_overlay .step-circle.done {\n  border-color: #22c55e;\n  background: #22c55e;\n  color: #fff;\n}\n\n.premium_loader_overlay .step-circle.active {\n  border-color: #e55a2b;\n  background: #fff;\n  color: #e55a2b;\n  box-shadow: 0 0 0 4px rgba(229, 90, 43, 0.15);\n}\n\n.premium_loader_overlay .step-circle.active::after {\n  content: \"\";\n  position: absolute;\n  inset: -4px;\n  border-radius: 50%;\n  border: 2px solid rgba(229, 90, 43, 0.3);\n  animation: premium_ripple 1.2s ease-out infinite;\n}\n\n@keyframes premium_ripple {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1.6);\n    opacity: 0;\n  }\n}\n\n.premium_loader_overlay .step-label {\n  font-size: 10px;\n  font-weight: 600;\n  color: #94a3b8;\n  letter-spacing: 0.3px;\n  transition: color 0.4s;\n}\n\n.premium_loader_overlay .step-label.done {\n  color: #22c55e;\n}\n\n.premium_loader_overlay .step-label.active {\n  color: #0d1f35;\n}\n\n.premium_loader_overlay .step-line {\n  height: 2px;\n  flex: 1;\n  background: #f1f5f9;\n  border-radius: 50px;\n  margin-bottom: 20px;\n  overflow: hidden;\n  position: relative;\n}\n\n.premium_loader_overlay .step-line-fill {\n  height: 100%;\n  width: 0;\n  background: linear-gradient(90deg, #22c55e, #e55a2b);\n  border-radius: 50px;\n  transition: width 0.6s ease;\n}\n\n.premium_loader_overlay .bar-wrap {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.premium_loader_overlay .bar-track {\n  width: 100%;\n  height: 6px;\n  background: #f1f5f9;\n  border-radius: 50px;\n  overflow: hidden;\n  position: relative;\n}\n\n.premium_loader_overlay .bar-shimmer {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    rgba(255, 255, 255, 0.7) 50%,\n    transparent 100%\n  );\n  animation: premium_shimmer 1.5s ease-in-out infinite;\n}\n\n@keyframes premium_shimmer {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(200%);\n  }\n}\n\n.premium_loader_overlay .bar-fill {\n  height: 100%;\n  width: 0;\n  border-radius: 50px;\n  position: relative;\n  background: linear-gradient(90deg, #e55a2b, #f59e0b, #22c55e);\n  transition: width 0.55s ease;\n}\n\n.premium_loader_overlay .bar-pct {\n  font-size: 11px;\n  font-weight: 700;\n  color: #94a3b8;\n  text-align: right;\n}\n\n.premium_loader_overlay .bar-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 5px;\n}\n\n.premium_loader_overlay .bar-head-label {\n  font-size: 11px;\n  font-weight: 700;\n  color: #94a3b8;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n.premium_loader_overlay .dots {\n  display: flex;\n  gap: 6px;\n}\n\n@keyframes premium_db {\n  0%,\n  80%,\n  100% {\n    transform: scale(0.4);\n    opacity: 0.2;\n  }\n  40% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.premium_loader_overlay .dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #cbd5e1;\n  animation: premium_db 1.2s ease-in-out infinite;\n}\n\n.premium_loader_overlay .dot:nth-child(2) {\n  animation-delay: 0.18s;\n}\n\n.premium_loader_overlay .dot:nth-child(3) {\n  animation-delay: 0.36s;\n}\n\n@media (max-width: 420px) {\n  .premium_loader_content {\n    width: calc(100vw - 32px);\n    gap: 24px;\n  }\n\n  .premium_loader_overlay .text-main {\n    width: 100%;\n  }\n\n  .premium_loader_overlay .text-main span {\n    white-space: normal;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
